import Modernizr from 'modernizr';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
declare global {
	interface Window {
		dataLayer:any;
	}
}

export function init(): void {
	// Init mobile navigation panel
	let $siteNav = $('.js-site-nav');
	let $mainNav = $('.js-main-nav');


	$('.js-main-nav-toggle').on('click', function (e) {
		e.preventDefault();

		// Hide the search if it's open
		$('body').toggleClass('state-nav-open');
		$('body').removeClass('.state-quick-search-open');
		$('.js-site-header-search').removeClass('state-open');
		$('.js-quick-search-results').removeClass('state-visible');
		$('.js-mobile-search-toggle').removeClass('state-open');
		$('.quick-search-box__input').val("");
		$siteNav.toggleClass('state-visible');
	});

	function trackTopLevelNavClick(navLinkText){
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'clickText' : navLinkText, //Insert the text of the main navigation item
			'event' : 'main_navigation'
		});
	}


	// Lock or Unlock Body Scroll based on if dropdown menu is open
	const targetNode = document.querySelector('.js-site-nav');
	if(targetNode) {
		const config = { attributes: true };
		const callback = function(mutationsList, observer) {
			for(const mutation of mutationsList) {
				if (mutation.type === 'attributes') {
					if(Modernizr.mq('(max-width: 767px)') && mutation.target.classList.contains('state-visible')) {
						disableBodyScroll(mutation.target);
					} else {
						enableBodyScroll(mutation.target);
					}
				}
			}
		};

		const observer = new MutationObserver(callback);
		observer.observe(targetNode, config);
	}



	// Init sub-navigation
	function closeAllSubNav(e: Event) {
		let $allSubNav = $('.js-sub-nav');
		let $target = $(e.target);

		let $closestSubnav = $target.closest('.js-sub-nav');

		if (e.type === 'click' && $closestSubnav.length) {
			return;
		}

		if ($allSubNav.filter('.state-visible').length) {
			$('.js-sub-nav-trigger').removeClass('state-sub-nav-open');
			$allSubNav.removeClass('state-visible');
			$('body').removeClass('state-nav-open');
		}


		// Cancel the delayed mouseenter handler if it has been set
		$('.js-sub-nav-trigger').data('hovered', false);
	}

	if($('.hero-image--absolute').length) {
		$mainNav.addClass('main-nav--reversed');
		$('.js-header-search').addClass('quick-search-box--reversed');
		$('.site-header__nav-toggle').addClass('site-header__nav-toggle--reversed');
	}

	if (Modernizr.coarsepointer) {
		// Desktop tap-on / tap-off operation
		$('.js-sub-nav-trigger').on('click', function (e) {
			let $this = $(this);
			if (!$this.hasClass('state-sub-nav-open') || $(e.target).is('.js-sub-nav-mobile-trigger')) {
				e.preventDefault();
				e.stopPropagation(); // Prevent this event from bubbling and triggering the close handler
			} else {
				$('.js-sub-nav-trigger').removeClass('state-sub-nav-open');
			}

			// Hide other open navs and show this nav
			$('.js-sub-nav-trigger').not(this).removeClass('state-sub-nav-open');
			$(this).toggleClass('state-sub-nav-open');

			let $closestSubNav = $(this).closest('.js-main-nav-item').find('.js-sub-nav');
			$closestSubNav.toggleClass('state-visible');
			$('.js-sub-nav').not($closestSubNav).removeClass('state-visible');

			trackTopLevelNavClick($this.text());
		});

		// Desktop tap-to-close
		$('.js-sub-nav-close').on('click', function(e) {
			$('.js-sub-nav-trigger').removeClass('state-sub-nav-open');
			$('.js-sub-nav').removeClass('state-visible');
		});

		// Mobile expand/collapse operation
		$('.js-sub-nav-mobile-trigger').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			var $trigger = $(this).closest('.js-sub-nav-trigger');
			// Hide other open navs and show this nav
			$('.js-sub-nav-trigger').not($trigger).removeClass('state-sub-nav-open');
			$trigger.toggleClass('state-sub-nav-open');

			let $closestSubNav = $trigger.closest('.js-main-nav-item').find('.js-sub-nav');

			if($closestSubNav.hasClass('state-visible')) {
				$closestSubNav.removeClass('state-visible');
			} else {
				$closestSubNav.addClass('state-visible');
			}

			let $allOtherSubNavs = $('.js-sub-nav').not($closestSubNav);
			$allOtherSubNavs.removeClass('state-visible');

			// Scroll to selected trigger
			var siteNavTop = $('.js-site-nav').get(0).scrollTop;
			var scrollOffset = $trigger.position().top - siteNavTop;

			$siteNav.animate({
				scrollTop: scrollOffset
			}, 250);
		});

		$('body').on('click', closeAllSubNav);
	} else {
		// Delayed hover operation: the megamenu covers a lot of the screen and is easy to trigger accidentally
		// Wait 250ms and if the user is still hovering, open the nav
		$('.js-sub-nav-trigger').on('mouseenter', function () {
			let linkText = $(this).text();
			// The closeAllSubnav() function (called on mouseleave) removes this property
			$(this).data('hovered', true);

			setTimeout(() => {
				if ($(this).data('hovered')) {
					$(this).addClass('state-sub-nav-open');
					$(this).closest('.js-main-nav-item').find('.js-sub-nav').addClass('state-visible');
				}
			}, 250);
		});

		$('.js-main-nav-item').on('mouseleave', closeAllSubNav);
		$('body').on('click', closeAllSubNav);
	}

	$('body').on('click.flyoutmenus', '.js-sub-nav a', function(e){
		let $this = $(this);
		let $content = $this.text().trim();
		trackTopLevelNavClick($content);
	});

	$('body').on('click', '.js-mobile-search-toggle', function(e){
		let $this = $(this);
		let $siteNav = $('.js-site-nav');
		let $headerSearch = $('.js-site-header-search');

		if(!$this.hasClass('state-open')) {
			if($siteNav.hasClass('state-visible')) {
				$( ".js-main-nav-toggle" ).trigger( "click" );
			}
			$this.addClass('state-open');
			$headerSearch.addClass('state-open');
			$('body').addClass('state-quick-search-open');
			$('.quick-search-box__input').focus();
		} else {
			$this.removeClass('state-open');
			$headerSearch.removeClass('state-open');
			$('body').removeClass('state-quick-search-open');

		}
  });

	$('body').on('click', '.js-footer-menu-trigger', function(e){
		e.preventDefault();
		let parent = $(e.target).closest('.footer-nav__section');
		let list = parent.find('.footer-nav__link-list');
		if(parent.hasClass('state-open')) {
			parent.removeClass('state-open');
		} else {
			parent.addClass('state-open');
		}
	});

	let headingElements = document.querySelectorAll('.footer-nav__heading');
	headingElements.forEach((heading) => {
		let parentItem = heading.parentElement;
		parentItem.classList.add('position-relative');
		//console.log(parentItem);
		if(!parentItem.querySelector('.js-footer-menu-trigger')) {
			let trigger = $('<a href="#" class="js-footer-menu-trigger footer-nav__trigger"><i class="icon-chevron-thin-down"></i></a>');
			trigger.appendTo(parentItem);
		}
	});


	//Google Tag Manager Tracking
	function trackQuickSearch(searchQuery) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'searchText' : searchQuery, //Insert the model number that was searched
			'event' : 'modelnum_searched_main'
		});
		//console.log(window.dataLayer);
	}

	//track quick search analytics
	$('.menu-quick-search').on('submit', function(){
		let $this = $(this);
		let inputValue = $this.find('input[type="text"]:first').val();
		trackQuickSearch(inputValue);
	});
}
